/**
 * Version Check Configuration
 * 
 * Controls the app auto-refresh feature that notifies users
 * when a new version is deployed.
 */

export const VERSION_CHECK_CONFIG = {
  // Enable version checking (disabled in development by default)
  // Set to true in dev to test locally
  enabled: process.env.REACT_APP_ENVIRONMENT !== 'development',
  
  // How often to check for updates (24 hours for all environments)
  // Lower for testing: 1 * 60 * 1000 (1 minute)
  checkInterval: 24 * 60 * 60 * 1000,
  
  // How long to show notification before auto-dismiss (null = never auto-dismiss)
  // User must explicitly dismiss or refresh
  notificationTimeout: null,
  
  // Force refresh after this time (null = never force, user decides)
  forceRefreshAfter: null,
  
  // Debug mode (logs additional info to console, only enabled in development)
  debugMode: process.env.REACT_APP_ENVIRONMENT === 'development',
  
  // Number of retries on network failure
  maxRetries: 3,
  
  // Initial delay before first check (30 seconds)
  // Gives app time to fully initialize
  initialDelay: 30000
};

export default VERSION_CHECK_CONFIG;






